"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributeWellKnownNames = void 0;
var StrategyAttributeWellKnownNames;
(function (StrategyAttributeWellKnownNames) {
    StrategyAttributeWellKnownNames["Device"] = "device";
    StrategyAttributeWellKnownNames["Country"] = "country";
    StrategyAttributeWellKnownNames["Platform"] = "platform";
    StrategyAttributeWellKnownNames["Userkey"] = "userkey";
    StrategyAttributeWellKnownNames["Session"] = "session";
    StrategyAttributeWellKnownNames["Version"] = "version";
})(StrategyAttributeWellKnownNames = exports.StrategyAttributeWellKnownNames || (exports.StrategyAttributeWellKnownNames = {}));
//# sourceMappingURL=strategy-attribute-well-known-names.js.map